export enum PaymentKindId {
	TRANSFER = 'transfer',
	SETTLEMENT = 'settlement',
	RECLASSIFICATION = 'reclassification',
	PAYU = 'PAYU',
	TPAY = 'TPAY',
	COMMISSION = 'commission',
	CASH = 'Cash',
	CARD = 'card',
}
